import React from "react";
import { formatTimeWithAMPM } from "../../utils/dateUtils";

export const to24HourTime = (hour, minute, period) =>
  `${String((Number(hour) % 12) + (period === "PM" ? 12 : 0)).padStart(2, "0")}:${minute}`;

// Native selects provide keyboard and mobile controls with explicit AM/PM,
// while callers continue receiving the same HH:mm change event shape.
export default function VenueTimeSelect({ value = "", onChange, name, id, className, dailyStart, required, disabled }) {
  const [hour = "", minute = "00"] = value.split(":");
  const period = Number(hour) >= 12 ? "PM" : "AM";
  const displayHour = hour === "" ? "" : String(Number(hour) % 12 || 12).padStart(2, "0");
  const update = (h, m, p) => onChange?.({ target: { name, value: h ? to24HourTime(h, m, p) : "" } });
  const label = name || id || (dailyStart ? "Daily end time" : "Daily start time");
  return <div>
    <div className="flex min-w-0 flex-wrap gap-1">
      <select id={id} aria-label={`${label} hour`} value={displayHour} required={required} disabled={disabled}
        style={{ minWidth: 0, flex: "1 1 3.5rem", padding: "0.5rem 0.25rem" }} className={className} onChange={(e) => update(e.target.value, minute, period)}>
        <option value="">Hour</option>
        {Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, "0")).map((h) => <option key={h}>{h}</option>)}
      </select>
      <select aria-label={`${label} minute`} value={minute} disabled={disabled} style={{ minWidth: 0, flex: "1 1 3.5rem", padding: "0.5rem 0.25rem" }} className={className}
        onChange={(e) => update(displayHour || "12", e.target.value, period)}>
        {Array.from({ length: 60 }, (_, i) => String(i).padStart(2, "0")).map((m) => <option key={m}>{m}</option>)}
      </select>
      <select aria-label={`${label} AM/PM`} value={period} disabled={disabled} style={{ minWidth: 0, flex: "1 1 3.5rem", padding: "0.5rem 0.25rem" }} className={className}
        onChange={(e) => update(displayHour || "12", minute, e.target.value)}>
        <option>AM</option><option>PM</option>
      </select>
    </div>
    {dailyStart && value && value < dailyStart && <p className="mt-2 text-xs" role="note">
      This daily time slot ends at {formatTimeWithAMPM(value).replace(/^0/, "")} on the following day.
    </p>}
  </div>;
}
